import { Helmet } from 'react-helmet-async'

export default function SEOHead({ 
  title = "C9 Recruitment - UK Transport & Logistics Recruitment Specialists",
  description = "Leading UK recruitment agency specializing in drivers, engineers, and logistics professionals. Find your next opportunity or hire top talent in transport & logistics.",
  keywords = "recruitment, transport, logistics, drivers, engineers, HGV, UK jobs, staffing",
  canonical = "",
  ogImage = "/og-image.jpg"
}) {
  const siteUrl = "https://c9recruitment.com"
  const fullTitle = title.includes("C9 Recruitment") ? title : `${title} | C9 Recruitment`
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="C9 Recruitment" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:site_name" content="C9 Recruitment" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />

      {/* Additional SEO Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#FF6E00" />
      <meta name="msapplication-TileColor" content="#FF6E00" />
      
      {/* Business Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "C9 Recruitment",
          "url": siteUrl,
          "logo": `${siteUrl}/logo.png`,
          "description": description,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Albany House, 162-168 High Street",
            "addressLocality": "Waltham Cross",
            "postalCode": "EN8 7DF",
            "addressCountry": "GB"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+44-20-8152-4574",
            "contactType": "Customer Service",
            "areaServed": "GB",
            "availableLanguage": "English"
          },
          "sameAs": [
            "https://linkedin.com/company/c9recruitment",
            "https://twitter.com/c9recruitment"
          ]
        })}
      </script>
    </Helmet>
  )
}
